import { AlertButton } from '@ionic/react'
import { AlertConstants } from './alert.constants'
import { IAlertAction, IAlertState } from './alert.types'

// todo: add english translation
export const initialAlertButtonState: AlertButton = {
  text: 'Ok',
}
export const initialAlertState: IAlertState = {
  header: '',
  subHeader: '',
  message: '',
  buttons: [initialAlertButtonState],
  showAlert: false,
  showEqualWidthButton: false,
}

export function alertReducer(state: IAlertState = initialAlertState, action: IAlertAction): IAlertState {
  switch (action.type) {
    case AlertConstants.SHOW_ALERT:
      return { ...state, ...action.alert, showAlert: true }
    case AlertConstants.RESET_SHOW_ALERT:
      return {
        header: '',
        subHeader: '',
        message: '',
        buttons: [initialAlertButtonState],
        showAlert: false,
        showEqualWidthButton: false,
      }
    default:
      return state
  }
}
